export enum DigitalizationDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP',
    THIRDGROUP = 'THIRDGROUP',
}
